module.exports = __webpack_public_path__ + "img/green_ball.1e32b3cc.svg";